import { Box, Button, Link } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import "./FeaturesAndExclusion.scss";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SelectFeature from "../../../Pages/Desktop/Broker/Quotes/SelectFeature/SelectFeature";
import Exclusion from "../../../Pages/Desktop/Broker/Quotes/Exclusion/Exclusion";

function FeaturesAndExclusion() {
  const [addFeature, setAddFeature] = React.useState<boolean>(false);
  const [Addexclusion, setAddExclusion] = React.useState(false);
  const updateMasterState = (attrName: any, value: any) => {
    // console.log("attrName(value)", attrName(value));
  };
  const exclusion_table = [
    {
      exclusion_name: "STD",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "AIDS",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Ectopic Pregnancy",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Hepatitis C",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Rabies",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
  ];

  const [featuresData, setFeaturesData] = useState<
    Array<{
      title: string;
      subData: Array<{
        title: string;
        price: string;
        subDataList: Array<string>;
      }>;
    }>
  >([
    {
      title: "Apollo Benefits",
      subData: [
        {
          title: "OPD Benefits",
          price: "Up to 25% discount on OPD and in-house investigations.",
          subDataList: ["Discount on OPD expenses"],
        },
        {
          title: "Retail Health Checkup",
          price: "Up to 20% discount on Retail Health check-up packages.",
          subDataList: ["Discount on Retail Health Checkups"],
        },
        {
          title: "Green Channel Entry",
          price: "Green Channel Entry for all Members",
          subDataList: ["Benefits of Green Channel Entry"],
        },
        {
          title: "Corporate Lounge",
          price: "Corporate Lounge Access for Health Checkups",
          subDataList: ["Corporate Lounge Access Benefits"],
        },
        {
          title: "Advantage Desk",
          price: "End to End Services through Advantage Desk Facilities",
          subDataList: ["Benefits of Advanbtage Desk Facilities"],
        },
      ],
    },
    {
      title: "Emergency Cover",
      subData: [
        {
          title: "Worldwide Emergency Hospitalisation",
          price: "₹ 786",
          subDataList: ["Upto Sum Insured"],
        },
      ],
    },
    {
      title: "Waiting Period",
      subData: [
        {
          title: "Pre-existing Diseases",
          price: "₹ 1086",
          subDataList: ["Covered After 3 Years"],
        },
        {
          title: "Ambulance Charges",
          price: "₹ 2000",
          subDataList: ["₹ 2,000 Per Hospitalisation"],
        },
      ],
    },
  ]);

  return (
    <>
      <SelectFeature
        open_status={addFeature}
        attrName={setAddFeature}
        value_update={updateMasterState}
      />
      <Exclusion
        open_status={Addexclusion}
        attrName={setAddExclusion}
        value_update={updateMasterState}
      />
      <Box className="voluntry_plans">
        <Grid
          container
          spacing={3}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Grid md={6} lg={5}>
            <div className="voluntry_features">
              <div>
                <div className="feature_img">
                  <img
                    src="../images/voluntry_feature_img.svg"
                    alt=""
                    className="voluntry_feature_img"
                  />
                  <h6>Features</h6>
                  <span className="action_edit">
                    <Link
                      className="action_btn action_btn_feature"
                      onClick={() => {
                        setAddFeature(true);
                      }}
                    >
                      <BorderColorIcon />
                    </Link>
                  </span>
                </div>
              </div>

              {featuresData.map((data) => (
                <div className="medical_cover mt-6">
                  <h5>{data.title}</h5>
                  {data.subData.map((subData) => (
                    <>
                      <Grid container spacing={3} className="px-0 pb-2">
                        <Grid xs={12}>
                          <p style={{ color: "#F5BE4C", fontWeight: 700 }}>
                            {subData.title}
                          </p>
                          <h6 style={{ textAlign: "left", marginTop: "12px" }}>
                            {subData.price}
                          </h6>
                        </Grid>
                      </Grid>
                      {subData.subDataList.map((dataList) => (
                        <Grid container spacing={3} className="px-0 py-0">
                          <Grid xs={12} className="py-0">
                            <ul style={{ paddingLeft: "0" }}>
                              <li style={{ opacity: "0.5", listStyle: "none" }}>
                                {dataList}
                              </li>
                            </ul>
                          </Grid>
                        </Grid>
                      ))}
                    </>
                  ))}
                </div>
              ))}
            </div>
          </Grid>
          <Grid md={6} lg={5}>
            <div className="voluntry_exclusion">
              <div className="exclusion_img">
                <img src="../images/voluntry_exclusion_img.svg" alt="" />
                <h6>Exclusion</h6>
                <span className="action_edit">
                  <Link
                    href=""
                    className="action_btn"
                    // onClick={() => {
                    //   setAddExclusion(true);
                    // }}
                  >
                    <BorderColorIcon />
                  </Link>
                </span>
              </div>
              <div className="exclusion_para">
                {exclusion_table.map((data, index) => (
                  <>
                    <h6>{data.exclusion_name}</h6>
                    <p>{data.exclusion_para}</p>
                    {index === exclusion_table.length - 1 ? null : <hr />}
                  </>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default FeaturesAndExclusion;
